export default __webpack_public_path__ + "static/media/heart.a039eefc.svg";